const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MIN_PASSWORD_LENGTH = 6;

export function normalizeEmail(email) {
  return String(email === undefined || email === null ? "" : email).trim().toLowerCase();
}

export function validateEmail(email) {
  const value = normalizeEmail(email);
  if (!value) return "Please enter your email";
  if (!EMAIL_PATTERN.test(value)) return "Please enter a valid email address";
  return "";
}

export function validatePassword(password) {
  const value = String(password === undefined || password === null ? "" : password);
  if (!value) return "Please enter your password";
  if (value.includes(" ")) return "Password cannot contain spaces";
  if (value.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;
  }
  return "";
}

export default {
  normalizeEmail,
  validateEmail,
  validatePassword,
};



// WEBPACK FOOTER //
// ./src/util/validation.js